module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-4-7261a40a5bd248e7ee7b744b41457731.jpg";